/* eslint-disable jsx-a11y/alt-text */
import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import UpdateDisputeRequestModalContent from "./UpdateDisputeRequestModalContent";
import ResendIcon from "../../../../assets/resend.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "20px 50px",
  borderRadius: "10px",
};

export default function UpdateDisputeModal({
  disputeId,
  messageDrawer,
  dispute,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* <Icon
        icon="material-symbols:edit-square-outline"
        width="20"
        height="20"
        style={{ cursor: "pointer", marginRight: "5px" }}
        onClick={handleOpen}
      /> */}

      <img
        src={ResendIcon}
        width={18}
        style={{ marginRight: 5 }}
        onClick={handleOpen}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <UpdateDisputeRequestModalContent
              disputeId={disputeId}
              dispute={dispute}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
